/**
 * @generated SignedSource<<fc4344b20580c77db802b78a8b446602>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type styleArticleAuthorBlockArticle$data = {
  readonly authors: ReadonlyArray<{
    readonly entityId: string;
    readonly " $fragmentSpreads": FragmentRefs<"authorNameAuthor">;
  } | null> | null;
  readonly createdDate: number | null;
  readonly publishedDate: number | null;
  readonly " $fragmentType": "styleArticleAuthorBlockArticle";
};
export type styleArticleAuthorBlockArticle$key = {
  readonly " $data"?: styleArticleAuthorBlockArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"styleArticleAuthorBlockArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "styleArticleAuthorBlockArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publishedDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Author",
      "kind": "LinkedField",
      "name": "authors",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "authorNameAuthor"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "entityId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "5f28164abecc49caa5f2acf03e770a13";

export default node;
